import { axiosRequest } from "@planbord/axios-request";
import { useQuery } from "@tanstack/vue-query";

export const useGetCustomer = () => {
  const baseUrl = "/api";

  return useQuery<string>({
    queryKey: ["getCustomer"],
    queryFn: () =>
      axiosRequest.get(`${baseUrl}/dashboard/customer`).then((res) => res.data),
    // Use the cache for 60 minutes
    staleTime: 60 * 60000,
  });
};
